import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CalendarComponent } from '../calendar/calendar.component';
import { MessageService } from '../../../core/services/messages/messages.service';
import { PropertyService } from '../../../core/services/properties/property.service';
import { Subject } from 'rxjs';
import { languages } from '../../../constants/language.constants';
import { ViewportService } from '@shared/common/services/viewport/viewport.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  standalone: false
})
export class DatePickerComponent implements OnInit, OnDestroy {
  private readonly _destruction$: Subject<void> = new Subject<void>();

  @Input() isFetching: boolean;
  @Input() showCalendar: boolean;
  @Input() selectedDatesLabel: string;
  @Input() selectedDates: Date[];
  @Input() currentLang: languages;
  @Input() classList: string;
  @Input() calendar: CalendarComponent;
  @Input() isSearchBar: boolean;
  @Output() shouldShowCalendar: EventEmitter<boolean>;
  @Input() horizontalLayout: boolean;
  @Input() readOnly: boolean;

  get isElements(): boolean {
    return !!(window as any).__isAngularElement__;
  }

  constructor(
    private readonly elemRef: ElementRef,
    private readonly messageService: MessageService,
    private readonly propertyService: PropertyService,
    private readonly viewportService: ViewportService
  ) {
    this.shouldShowCalendar = new EventEmitter();
  }

  ngOnInit() {
    this.propertyService.openCalendarSubject.pipe(takeUntil(this._destruction$)).subscribe((isOpen: boolean) => {
      if (!isOpen) {
        return;
      }

      if (!this.showCalendar) {
        this.showHideCalendar();
      }
    });
  }

  ngOnDestroy(): void {
    this._destruction$.next();
    this._destruction$.complete();
    this.messageService.updateOverlayStatus(false, false);
  }

  /**
   * @description
   * Close Drop Down by click outside
   */
  @HostListener('document:click', ['$event'])
  clickOutsideDropDown(event) {
    if (
      event.target.className instanceof SVGAnimatedString
        ? true
        : (typeof event.target.className === 'string' || event.target.className instanceof String) &&
          event.target.className.indexOf('suite__btn--empty') < 0 &&
          !this.calendar.elemRef.nativeElement.contains(event.composedPath()[0]) &&
          !this.elemRef.nativeElement.contains(event.composedPath()[0])
    ) {
      if (this.showCalendar) {
        this.showCalendar = false;
        this.shouldShowCalendar.emit(this.showCalendar);
      }
    }
  }

  /**
   * @description
   * Shows/Hides the calendar
   */
  showHideCalendar(event?: Event): void {
    if (this.readOnly) {
      return;
    }

    this.showCalendar = !this.showCalendar;
    this.shouldShowCalendar.emit(this.showCalendar);

    this.sendOverlayMessages();

    if (this.showCalendar) {
      setTimeout(() => {
        this.propertyService.openCalendarSubject.next(false);
      });
    }
  }

  /**
   * @description
   * Send message to header component
   */
  sendOverlayMessages() {
    this.messageService.updateOverlayStatus(
      this.showCalendar,
      this.showCalendar,
      this.viewportService.isTabletDevice()
    );
  }
}
